import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  INFRA_MAP_REFRESH_API,
  INFRA_MAP_STORE,
  INFRA_MAP_STORE_LIST,
  INFRA_MAP_STORE_REFRESH,
} from '../constants';

const api = () =>
  pepApiRequest({
    method: RequestMethod.Post,
    url: INFRA_MAP_REFRESH_API,
    useProxy: true,
  });

// datasetHashKey: INFRA_MAP_STORE_LIST so refresh writes into state.list
const infraMapRefreshSlice = createDatasetSlice({
  api,
  storeName: INFRA_MAP_STORE,
  actionName: INFRA_MAP_STORE_REFRESH,
  datasetHashKey: INFRA_MAP_STORE_LIST,
  responseMapping: ResponseMapping.Default,
});

export default infraMapRefreshSlice;
